import { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import styles from "../styles/adminBrandsComponent.module.css";
import btnStyles from "../styles/globalButtonStylng.module.css";
import { AdminInstance } from "../utils/adminClass";

export const AdminAddUserFormComponent = ({
  closeForm,
  data,
  setInputs,
}: {
  closeForm: Function;
  data: any;
  setInputs: any;
}) => {
  const [userBlob, setUserBlob] = useState<Record<string, any>>({});
  const [canSubmit, setCanSubmit] = useState(false);
  const requiredFields = [
    "username",
    "email",
    "firstName",
    "dateOfBirth",
    "gender",
    "medicalCard",
    "preferredStrain",
    "experienceLevel",
  ];

  const submitUser = async (user: any) => {
    console.log("submitting user:", user);

    const res = await AdminInstance.adminCreateUser(user);

    if (res) {
      console.log("user created:", res);
      closeForm();
    }
  };

  const handleInputChange = (event: any) => {
    const { name, value } = event.target;
    console.log(`form updating ${name} with ${value}`);
    setUserBlob({
      ...userBlob,
      [name]: value,
    });
  };

  //checks inputs to make sure all fields are filled
  useEffect(() => {
    const isFilled = requiredFields.every((field) => userBlob[field]);
    setCanSubmit(isFilled);
    console.log("here's the user:", userBlob);
  }, [userBlob]);

  return (
    <Form className={styles.wrapper} id="addUserForm">
      <Form.Group className="mb-3" controlId="formBasicUsername">
        <Form.Label>Username</Form.Label>
        <Form.Control type="text" placeholder="New Username" name="username" onChange={handleInputChange} />
        <Form.Text className="text-muted">New username needs to be unique.</Form.Text>
      </Form.Group>
      <Form.Group className="mb-3" controlId="formBasicEmail">
        <Form.Label>Email address</Form.Label>
        <Form.Control type="email" placeholder="Enter email" name="email" onChange={handleInputChange} />
        <Form.Text className="text-muted">We never share emails with anyone else.</Form.Text>
      </Form.Group>
      <Form.Group className="mb-3" controlId="formBasicFirstName">
        <Form.Label>First Name</Form.Label>
        <Form.Control type="text" placeholder="First name" name="firstName" onChange={handleInputChange} />
      </Form.Group>
      <Form.Group className="mb-3" controlId="formBasicDateOfBirth">
        <Form.Label>Date of Birth</Form.Label>
        <Form.Control type="date" placeholder="Date of Birth" name="dateOfBirth" onChange={handleInputChange} />
      </Form.Group>
      <Form.Group className="mb-3" controlId="formBasicGender">
        <Form.Label>Gender</Form.Label>
        <div key="inline-radio" className="mb-3">
          <Form.Check
            inline
            label="Male"
            name="gender"
            type="radio"
            id="male-radio"
            value="male"
            onChange={handleInputChange}
          />
          <Form.Check
            inline
            label="Female"
            name="gender"
            type="radio"
            id="female-radio"
            value="female"
            onChange={handleInputChange}
          />
          <Form.Check
            inline
            label="Non-binary"
            name="gender"
            type="radio"
            id="non-binary-radio"
            value="non-binary"
            onChange={handleInputChange}
          />
        </div>
      </Form.Group>
      <Form.Group className="mb-3" controlId="formBasicMedicalCard">
        <Form.Label>Medical Card</Form.Label>
        <Form.Check
          label="No"
          name="medicalCard"
          type="radio"
          id="medicalCard-no-radio"
          value="no"
          onChange={handleInputChange}
        />
        <Form.Check
          label="Yes"
          name="medicalCard"
          type="radio"
          id="medicalCard-yes-radio"
          value="yes"
          onChange={handleInputChange}
        />
      </Form.Group>
      <Form.Group className="mb-3" controlId="formBasicPreferredStrain">
        <Form.Label>Preferred Strain</Form.Label>
        <div>
          <Form.Check
            type="radio"
            label="Indica"
            name="preferredStrain"
            id="indica-radio"
            value="indica"
            onChange={handleInputChange}
          />
          <Form.Check
            type="radio"
            label="Sativa"
            name="preferredStrain"
            id="sativa-radio"
            value="sativa"
            onChange={handleInputChange}
          />
          <Form.Check
            type="radio"
            label="Hybrid"
            name="preferredStrain"
            id="hybrid-radio"
            value="hybrid"
            onChange={handleInputChange}
          />
          <Form.Check
            type="radio"
            label="CBD"
            name="preferredStrain"
            id="cbd-radio"
            value="cbd"
            onChange={handleInputChange}
          />
          <Form.Check
            type="radio"
            label="No idea"
            name="preferredStrain"
            id="no-idea-radio"
            value="no idea"
            onChange={handleInputChange}
          />
          <Form.Check
            type="radio"
            label="Any and all"
            name="preferredStrain"
            id="any-and-all-radio"
            value="any and all"
            onChange={handleInputChange}
          />
        </div>
      </Form.Group>
      <Form.Group className="mb-3" controlId="formBasicExperienceLevel">
        <Form.Label>Experience Level</Form.Label>
        <div>
          <Form.Check
            type="radio"
            label="Beginner"
            name="experienceLevel"
            id="beginner-radio"
            value="beginner"
            onChange={handleInputChange}
          />
          <Form.Check
            type="radio"
            label="Casual"
            name="experienceLevel"
            id="casual-radio"
            value="casual"
            onChange={handleInputChange}
          />
          <Form.Check
            type="radio"
            label="Advanced"
            name="experienceLevel"
            id="advanced-radio"
            value="advanced"
            onChange={handleInputChange}
          />
          <Form.Check
            type="radio"
            label="Expert"
            name="experienceLevel"
            id="expert-radio"
            value="expert"
            onChange={handleInputChange}
          />
        </div>
      </Form.Group>
      <Form.Group className="mb-3" controlId="formBasicCheckbox">
        <Form.Check type="checkbox" label="I am not a robot" />
      </Form.Group>
      <Button
      className={btnStyles.Submit}
        disabled={!canSubmit}
        variant="primary"
        type="submit"
        onClick={(e) => {
          e.preventDefault();
          submitUser(userBlob);
          // closeForm();
        }}
      >
        Create User
      </Button>
    </Form>
  );
};
